import { render, staticRenderFns } from "./ItemShop.vue?vue&type=template&id=30d20658&scoped=true"
import script from "./ItemShop.vue?vue&type=script&lang=ts"
export * from "./ItemShop.vue?vue&type=script&lang=ts"
import style0 from "./ItemShop.vue?vue&type=style&index=0&id=30d20658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d20658",
  null
  
)

export default component.exports